// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer .btn {\n  width: 68px;\n}\n::v-deep .el-button:hover {\n  color: var(--mainColor);\n  border-color: var(--mainColor) !important;\n}", ""]);
// Exports
module.exports = exports;
